export default __webpack_public_path__ + "img/shape-closed-arc-small.5ce88970.svg";